import React from 'react'
import ChartWidgets from '../../../Components/Widgets/Chart'
import Breadcrumbs from '../../../CommonElements/Breadcrumbs'
import { ChartTitle, WidgetsTitle } from '../../../Utils/Constants'
import BorderTabs from '../../../Components/UiKits/Tabs/BorderTabs'
import MyProfile from '../../../Components/Apps/Users/EditProfile/MyProfile'
import EditProfileContainer from '../../../Components/Apps/Users/EditProfile'

export default function Profile() {
    return (
        <div className='page-body'>
            <Breadcrumbs pageTitle={'Profile'} parent={WidgetsTitle} title={ChartTitle} />
            {/* <MyProfile /> */}
            <EditProfileContainer />
          
            {/* <BorderTabs /> */}

        </div>
    )
}
